import React from 'react';
import { connect } from 'react-redux';
import { requestUrl } from '@/constants/urls';
import DropdownItem from '@/components/DropdownItem';
import StandardToolsMenu from '@/components/tools/StandardToolsMenu';
import { showApproveRequest, showArchiveRequest } from '../actions';
import { approvalStatus } from '../constants';
import { requestAccessContext, accessControlAsApprover } from '../helper';

const ReviewRequestTools = ({
  allowApprove,
  allowArchive,
  allowAudit,
  allowRead,
  category,
  listItem = false,
  request,
  showApprove,
  showArchive,
  upward,
  url,
  waiting,
}) => (
  <StandardToolsMenu
    allowDelete={allowArchive}
    allowRead={allowRead}
    href={url}
    listItem={listItem}
    onDelete={() => showArchive(category, request.code)}
    deleteIcon="archive"
    deleteMessage="actions.archive"
    upward={upward}
  >
    {allowApprove && (
      <>
        <DropdownItem
          icon="thumbs up"
          textId="actions.approve"
          onClick={() => showApprove(category, request.code, approvalStatus.APPROVE)}
          disabled={request.status !== approvalStatus.PENDING || waiting}
        />
        <DropdownItem
          icon="thumbs down"
          textId="actions.deny"
          onClick={() => showApprove(category, request.code, approvalStatus.DENY)}
          disabled={request.status !== approvalStatus.PENDING || waiting}
        />
      </>
    )}
    {allowAudit && (<DropdownItem icon="history" textId="actions.audit" href={`${requestUrl(request, '#')}/audits`} />)}
  </StandardToolsMenu>
);

const mapStateToProps = ({
  auth: {
    role,
    currentUser,
  },
}, { request }) => (
  accessControlAsApprover(requestAccessContext(request, currentUser), role)
);

const mapDispatchToProps = {
  showApprove: showApproveRequest,
  showArchive: showArchiveRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewRequestTools);
